// ISOLATED — Weekly Challenges (Desafíos semanales) ES/EN/SK dictionary.
// Kept separate from `shadow.js` and `shadow-fases.js` per the
// "do not modify shared files" rule.

const DICT = {
  es: {
    nav_back: "// SHADOW NETWORK",
    eyebrow: "// GAMIFICATION · WEEKLY CHALLENGES",
    title: "Desafíos semanales",
    sub: "Completa misiones cada semana para ganar R₿L y XP. Se renuevan cada lunes a las 00:00 UTC.",

    login_sub: "Inicia sesión para hacer track de tu progreso.",
    login_btn: "Iniciar sesión",

    week_label: "Semana",
    countdown_label: "Renuevan en",
    days: "d", hours: "h", minutes: "m", seconds: "s",

    earned_this_week: "Ganado esta semana",
    earned_rbl: "R₿L",
    earned_xp: "XP",
    earned_completed: "Completados",
    earned_total_xp: "XP total",
    earned_level: "Nivel",

    progress_label: "Progreso",
    of: "de",
    completed_badge: "Completado ✓",
    completed_at: "Conseguido el {date}",
    reward_label: "Recompensa",

    history_title: "Historial",
    history_empty: "Aún no has completado ningún desafío. ¡Empieza esta semana!",
    history_week: "Semana {w}",

    err_load: "Error cargando desafíos",
    loading: "Cargando…",

    cta_publish: "Publicar análisis →",
    cta_reactions: "Ir al feed →",
    cta_correct: "Mis análisis →",
    cta_referrals: "Mi código de referido →",

    // Levels
    lvl_rookie: "Rookie",
    lvl_trader: "Trader",
    lvl_shadow: "Shadow",
    lvl_legend: "Legend",
    lvl_progress_label: "{xp} XP · {label}",
  },
  en: {
    nav_back: "// SHADOW NETWORK",
    eyebrow: "// GAMIFICATION · WEEKLY CHALLENGES",
    title: "Weekly challenges",
    sub: "Complete missions every week to earn R₿L and XP. Renews every Monday at 00:00 UTC.",

    login_sub: "Sign in to track your progress.",
    login_btn: "Sign in",

    week_label: "Week",
    countdown_label: "Renews in",
    days: "d", hours: "h", minutes: "m", seconds: "s",

    earned_this_week: "Earned this week",
    earned_rbl: "R₿L",
    earned_xp: "XP",
    earned_completed: "Completed",
    earned_total_xp: "Total XP",
    earned_level: "Level",

    progress_label: "Progress",
    of: "of",
    completed_badge: "Completed ✓",
    completed_at: "Achieved on {date}",
    reward_label: "Reward",

    history_title: "History",
    history_empty: "You haven't completed any challenge yet. Start this week!",
    history_week: "Week {w}",

    err_load: "Error loading challenges",
    loading: "Loading…",

    cta_publish: "Publish analysis →",
    cta_reactions: "Go to feed →",
    cta_correct: "My analyses →",
    cta_referrals: "My referral code →",

    lvl_rookie: "Rookie",
    lvl_trader: "Trader",
    lvl_shadow: "Shadow",
    lvl_legend: "Legend",
    lvl_progress_label: "{xp} XP · {label}",
  },
  sk: {
    nav_back: "// SHADOW NETWORK",
    eyebrow: "// GAMIFICATION · WEEKLY CHALLENGES",
    title: "Týždenné výzvy",
    sub: "Plň úlohy každý týždeň a získavaj R₿L a XP. Obnovuje sa každý pondelok o 00:00 UTC.",

    login_sub: "Prihlás sa na sledovanie svojho pokroku.",
    login_btn: "Prihlásiť sa",

    week_label: "Týždeň",
    countdown_label: "Obnoví sa o",
    days: "d", hours: "h", minutes: "m", seconds: "s",

    earned_this_week: "Získané tento týždeň",
    earned_rbl: "R₿L",
    earned_xp: "XP",
    earned_completed: "Splnené",
    earned_total_xp: "Celkové XP",
    earned_level: "Úroveň",

    progress_label: "Pokrok",
    of: "z",
    completed_badge: "Splnené ✓",
    completed_at: "Dosiahnuté {date}",
    reward_label: "Odmena",

    history_title: "História",
    history_empty: "Zatiaľ si nesplnil žiadnu výzvu. Začni tento týždeň!",
    history_week: "Týždeň {w}",

    err_load: "Chyba pri načítaní výziev",
    loading: "Načítava sa…",

    cta_publish: "Publikovať analýzu →",
    cta_reactions: "Prejsť na feed →",
    cta_correct: "Moje analýzy →",
    cta_referrals: "Môj referral kód →",

    lvl_rookie: "Rookie",
    lvl_trader: "Trader",
    lvl_shadow: "Shadow",
    lvl_legend: "Legenda",
    lvl_progress_label: "{xp} XP · {label}",
  },
  "zh-CN": {
    nav_back: "// SHADOW NETWORK",
    eyebrow: "// 游戏化 · 每周挑战",
    title: "每周挑战",
    sub: "每周完成任务以赚取R₿L和XP。每周一00:00 UTC刷新。",
    login_sub: "登录以跟踪您的进度。",
    login_btn: "登录",
    week_label: "第",
    countdown_label: "刷新倒计时",
    days: "天",
    hours: "时",
    minutes: "分",
    seconds: "秒",
    earned_this_week: "本周已获得",
    earned_rbl: "R₿L",
    earned_xp: "XP",
    earned_completed: "已完成",
    earned_total_xp: "总XP",
    earned_level: "等级",
    progress_label: "进度",
    of: "/",
    completed_badge: "已完成 ✓",
    completed_at: "完成于{date}",
    reward_label: "奖励",
    history_title: "历史记录",
    history_empty: "您还未完成任何挑战。本周开始吧！",
    history_week: "第{w}周",
    err_load: "加载挑战时出错",
    loading: "加载中…",
    cta_publish: "发布分析 →",
    cta_reactions: "前往动态 →",
    cta_correct: "我的分析 →",
    cta_referrals: "我的推荐码 →",
    lvl_rookie: "Rookie",
    lvl_trader: "Trader",
    lvl_shadow: "Shadow",
    lvl_legend: "Legend",
    lvl_progress_label: "{xp} XP · {label}",
  },
  de: {
    nav_back: "// SHADOW NETWORK",
    eyebrow: "// GAMIFICATION · WÖCHENTLICHE HERAUSFORDERUNGEN",
    title: "Wöchentliche Herausforderungen",
    sub: "Schließe jede Woche Missionen ab, um R₿L und XP zu verdienen. Erneuern sich jeden Montag um 00:00 UTC.",
    login_sub: "Melde dich an, um deinen Fortschritt zu verfolgen.",
    login_btn: "Anmelden",
    week_label: "Woche",
    countdown_label: "Erneuern in",
    days: "T",
    hours: "Std",
    minutes: "Min",
    seconds: "Sek",
    earned_this_week: "Diese Woche verdient",
    earned_rbl: "R₿L",
    earned_xp: "XP",
    earned_completed: "Abgeschlossen",
    earned_total_xp: "Gesamt-XP",
    earned_level: "Level",
    progress_label: "Fortschritt",
    of: "von",
    completed_badge: "Abgeschlossen ✓",
    completed_at: "Erreicht am {date}",
    reward_label: "Belohnung",
    history_title: "Verlauf",
    history_empty: "Du hast noch keine Herausforderung abgeschlossen. Starte diese Woche!",
    history_week: "Woche {w}",
    err_load: "Fehler beim Laden der Herausforderungen",
    loading: "Lädt…",
    cta_publish: "Analyse veröffentlichen →",
    cta_reactions: "Zum Feed →",
    cta_correct: "Meine Analysen →",
    cta_referrals: "Mein Empfehlungscode →",
    lvl_rookie: "Rookie",
    lvl_trader: "Trader",
    lvl_shadow: "Shadow",
    lvl_legend: "Legend",
    lvl_progress_label: "{xp} XP · {label}",
  },
};

export function tCh(lang, key, params) {
  const dict = DICT[lang] || DICT.es;
  let s = dict[key];
  if (s === undefined) s = (DICT.es && DICT.es[key]) || key;
  if (params && typeof s === "string") {
    for (const [k, v] of Object.entries(params)) {
      s = s.split(`{${k}}`).join(String(v));
    }
  }
  return s;
}

export function pickLocalized(obj, lang) {
  if (!obj) return "";
  if (typeof obj === "string") return obj;
  return obj[lang] || obj.es || obj.en || "";
}

export const LEVEL_LABEL_KEY = {
  rookie: "lvl_rookie",
  trader: "lvl_trader",
  shadow: "lvl_shadow",
  legend: "lvl_legend",
};
